import React, { useState, useEffect, useContext } from 'react';
import UserDetailsContext from '../context/userDetails.context';
import ThemeContext from '../context/theme.Context';
import LoadingContext from '../context/loading.context';
import Spinner from './Spinner.component';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { LinkContainer } from 'react-router-bootstrap';
import * as Constants from '../modules/constants';


function Invitation(props) {

    const { token } = useContext(UserDetailsContext);
    const { showLoading, hideLoading } = useContext(LoadingContext);

    const [feedback, setFeedback] = useState('');
    const [linkTo, setLinkTo] = useState('');
    const [linkText, setLinkText] = useState('');

    const apiHostName = Constants.API_URL;

    useEffect(() => {

        function acceptInvitation(invitationId, feedbackMessage, linkText, linkTo) {
            showLoading();
            fetch(apiHostName + '/v1/invitations/' + invitationId + '/accept', {
                mode: "cors",
                method: 'PUT', headers: { "Authorization": "Bearer " + token }
            })
                .then(function (response) {
                    console.log(response);
                    if (!response.ok) {
                        throw new Error("Invalid network response");
                    }
                    return response.text();
                })
                .then((result) => {
                    // Ok!
                    if (linkText) {
                        setLinkText(linkText);
                        setLinkTo(linkTo);
                    }
                    hideLoading();
                    setFeedback(feedbackMessage);
                })
                .catch(function (error) {
                    // Set visual cue and error text to be displayed on login screen
                    console.error("Accepting invitation failed...");
                    console.error(error);
                    hideLoading();
                    setFeedback('Invitation cannot be processed currently (network error).');
                });
        }



        // Check query parameter: should contain the invitation ID:
        const index = props.location.search.indexOf('id=');
        if (index < 0) {
            // No invitation ID specified - redirect to /
            props.history.push('/');
            return;
        }

        showLoading();
        // Check this invitation ID:
        var invitationId = props.location.search.substring(index + 3);
        if (invitationId.indexOf('&') >= 0) {
            invitationId = invitationId.substring(0, invitationId.indexOf('&'));
        }
        // Check if it's a valid invitation on the server:
        fetch(apiHostName + '/v1/invitations/' + invitationId + '/status', {
            mode: "cors",
            method: 'GET',
            cache: "no-cache",
            headers: { "Authorization": "Bearer " + token }
        })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error('Network error');
                }
                return response.json();
            })
            .then((result) => {
                // Result contains invitation details (if any) Check the state, could be NotFound, Pending, Accepted, Expired, Cancelled
                // If Pending, it's ok. For Expired, show a message to indicate that. Otherwise, show "Invitation not found or not valid."
                switch (result.state) {
                    case 1: // Accepted
                    case 3: //Cancelled
                    case 4: // NotFound
                        setFeedback('Invitation not found or not valid.');
                        break;
                    case 2: // Expired
                        setFeedback('Your invitation has expired. Please ask for a new invitation.');
                        break;
                    case 0: // Pending
                        /* The invitation is valid. 
                         * - If the user is logged in, add the location to his/her locations
                         * - If the user is not logged in and
                         *      - the e-mail address in the invitation is associated to an existing user, redirect to the login page
                         *      - the e-mail address in the invitation is not associated to an existing user, redirect to the registration page
                         * */
                        if (token.length > 0) {
                            acceptInvitation(result.id, 'The invitation has been processed successfully. Refresh the app in order to use the new location.', 'Refresh', '/');
                        }
                        else {
                            if (result.forExistingUser) {
                                // Accept invitation, then redirect to login page:
                                // Call server to accept invitation
                                acceptInvitation(result.id, 'The invitation has been processed successfully. Please login to see the new location.', 'Login', '/login');
                            }
                            else {
                                setFeedback('In order to accept the invitation, please register first. Make sure you use the e-mail address that has been used for this invitation, otherwise you won\'t be able to use the invitation after registration.');
                                setLinkTo('/register?email=' + result.email);
                                setLinkText('Register here');
                            }
                        }

                        break;
                    default:
                        setFeedback('Invitation not found or not valid.');
                }
                hideLoading();
            })
            .catch(function (error) {
                // Set visual cue and error text to be displayed on registration screen
                console.error("Cannot retrieve invitations...");
                console.error(error);
                setFeedback('Your invitation cannot be retrieved at the moment (network error).');
                hideLoading();
            });

    }
        , [apiHostName, showLoading, hideLoading, props.location.search, props.history, token]);

    return (
        <ThemeContext.Consumer>
            {(themeContext) => (
                <Card bg={themeContext.theme} text={themeContext.textColor}>
                    <Card.Body>
                        <Card.Title  >
                            Your invitation
                        </Card.Title>
                        <Card.Subtitle>
                            {feedback.length === 0 &&
                                <div>Checking your invitation... <Spinner /></div>
                            }
                        </Card.Subtitle>
                        <Card.Text as="div">
                            {feedback.length > 0 &&
                                <React.Fragment>
                                    <div>{feedback}</div>
                                    <div>{linkText &&
                                        <LinkContainer to={linkTo} style={{ marginTop: '16px' }}>
                                            <Button variant='secondary'>{linkText}</Button>
                                        </LinkContainer>
                                    }
                                    </div>
                                </React.Fragment>
                            }
                        </Card.Text>
                    </Card.Body>
                </Card>
            )}
        </ThemeContext.Consumer>
    );
}

export default Invitation;


// WEBPACK FOOTER //
// ./src/components/Invitation.js